// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a[data-v-7e98fad4]{color:#000}.info-about-doctor[data-v-7e98fad4]{width:100%}.info-about-doctor .avatar-wrapper[data-v-7e98fad4]{position:relative;border-radius:50%;overflow:hidden;-webkit-box-shadow:0 7px 15px rgba(0,0,0,.058823529411764705);box-shadow:0 7px 15px rgba(0,0,0,.058823529411764705)}.info-about-doctor .name[data-v-7e98fad4]{font-size:22px}@media (max-width:578px){.info-about-doctor .name[data-v-7e98fad4]{font-size:20px}}", ""]);
// Exports
module.exports = exports;
